module.exports = __webpack_public_path__ + "media/images/official/event_banner_sp-1e11e783f6b3921a09f89eb39e53b91f.jpg";